import { FreteFaixaPercentual } from './frete-faixa-percentual';

export class Frete {
  id: number;
  ibge: string;
  uf: string;
  cidade: string;
  prazoTotal: number;
  prazoColeta: number;
  prazoDespacho: number;
  valor: number;
  idTransportadora: number;
  transportadora: string;
  percentualNfe: number;
  faixas: FreteFaixaPercentual[];
  idCD?: number;
  freteMinimo: number;
  taxaRural: number;
  somenteFOB: number;
  idModalidade?: number;
  modalidade: string;
  modalidadePadrao: boolean;
  tda: number;
  valorFrete: number;
  peso: number;
  pedagio: number;

  //
  selecionado: boolean;
  alterou: boolean;
}
